import { render, staticRenderFns } from "./Collaboration.vue?vue&type=template&id=2898a550&scoped=true"
import script from "./Collaboration.vue?vue&type=script&lang=js"
export * from "./Collaboration.vue?vue&type=script&lang=js"
import style0 from "./Collaboration.vue?vue&type=style&index=0&id=2898a550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2898a550",
  null
  
)

export default component.exports